export enum FieldType {
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  USER = 'USER',
  CHECKBOX = 'CHECKBOX',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  VEHICLE_DEPARTMENT = 'VEHICLE_DEPARTMENT',
}
